import Component from '../abstracts/Component';
import {doAjax} from '../utils/ajaxUtil';

export default class NotifyMeComponent extends Component {

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      nofityWrapper: '[data-notify-me-wrapper]',
      form: '[data-notify-me-form-container] form',
      notifyMeBtn : '[data-notifyme=buttons]',
      addToCartBtn: '[data-addtocart=buttons]',
      sizeHiddenInput: '[data-notify-me-size]',
      mailErrorBox: '[data-mail-errors]',
      mailInput: 'input[name="email"]',
      sizeError: '.js-addtocart-notification',
      wishlistSelector: '.p-my-account__wishlist-selector',
      pdpProduct: '.c-pdp__service-column',
      notifyMeThanks: '[data-notify-me-thanks]',
      notifyMeThanksText: '[data-notify-me-thanks-text]',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      btnHidden: 'hidden',
      enableNotify: 'product-sizes-notify',
      error: 'error',
      loading: 'loading'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.parent = this.$component.closest(this.SELECTORS.wishlistSelector) || this.$component.closest(this.SELECTORS.pdpProduct);
    // component elements
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.notifyMeThanks = this.$component.querySelector(this.SELECTORS.notifyMeThanks);

    // outside components
    this.notifyMeBtn = this.parent.querySelector(this.SELECTORS.notifyMeBtn);
    this.addToCartBtn = this.parent.querySelector(this.SELECTORS.addToCartBtn);
    this.nofityWrapper = this.parent.querySelector(this.SELECTORS.nofityWrapper);
    this.sizeHiddenInput = this.parent.querySelector(this.SELECTORS.sizeHiddenInput);
    this.mailInput = this.parent.querySelector(this.SELECTORS.mailInput);
    this.mailErrorBox = this.parent.querySelector(this.SELECTORS.mailErrorBox);
    this.sizeError = this.parent.querySelector(this.SELECTORS.sizeError);

  }

  // FORM FUNCTIONS
  toggleUnavailableForm(payload, show = true) {
    // get product element
    let parentEl = payload.closest(this.SELECTORS.wishlistSelector) || payload.closest(this.SELECTORS.pdpProduct);
    if (show) {
      // show form
      parentEl.querySelector(this.SELECTORS.nofityWrapper).classList.add(this.CLASSES.show);
      // show notify btn
      parentEl.querySelector(this.SELECTORS.notifyMeBtn).classList.remove(this.CLASSES.btnHidden);
      // hide atc
      parentEl.querySelector(this.SELECTORS.addToCartBtn).classList.add(this.CLASSES.btnHidden);
    } else {
      // hide form
      parentEl.querySelector(this.SELECTORS.nofityWrapper).classList.remove(this.CLASSES.show);
      // show atc
      parentEl.querySelector(this.SELECTORS.addToCartBtn).classList.remove(this.CLASSES.btnHidden);
      // hide notify btn
      parentEl.querySelector(this.SELECTORS.notifyMeBtn).classList.add(this.CLASSES.btnHidden);
    }
    // hide thanks
    this.notifyMeThanks.classList.remove(this.CLASSES.show);
  }

  notifySend() {
    // global
    let ctx = this;
    // i need a check to bind only once
    if (this.notifyMeBtn.getAttribute('data-bind-notify') !== 'true')  {
      // click on notify button
      this.notifyMeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let uniqueSize = this.notifyMeBtn.dataset.uniqueSize === 'true' ;
        // if there is the selected size and uniquesize is false or if uniquesize is true
        if ( (this.sizeHiddenInput.value !== '' && !uniqueSize ) || uniqueSize ) {
          // trigger sumbit form
          this.notifySubmit(this.form);
        } else {
          // no size selected , let's trigger the size required error
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, this.notifyMeBtn);
        }
      });
      // for the check
      this.notifyMeBtn.setAttribute('data-bind-notify','true');
    }
  }

  notifySubmit(form) {
    // check
    if (form == null) return false;
    // global
    let ctx = this;
    // get url for ajax
    let url = form.getAttribute('action');
    // reset errors
    form.classList.remove(this.CLASSES.error);
    // SHOW LOADING
    form.classList.add(this.CLASSES.loading);
    this.notifyMeBtn.classList.add(this.CLASSES.loading);
    // do ajax
    doAjax({
      type: "POST",
      url: url,
      data: $(form).serialize(),
      success: function(message, textStatus, xhr){
        // HIDE LOADING
        ctx.notifyMeBtn.classList.remove(ctx.CLASSES.loading);
        form.classList.remove(ctx.CLASSES.loading);
        // end notify
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeended , {box: ctx.nofityWrapper, message: message });
      },
      error: function(xhr){
        // hide loading
        ctx.notifyMeBtn.classList.remove('loading');
        form.classList.remove(ctx.CLASSES.loading);
        // error
        ctx.log('notifyMe submit error',xhr);
        // insert error
        ctx.mailErrorBox.innerHTML = xhr.responseText;
        ctx.mailErrorBox.classList.remove('hidden');
        // adding class
        form.classList.add(ctx.CLASSES.error);
      }
    });
  }

  // ADD TO CART WITH NO FORM
  toggleAddToCartError(enable = true , productcode = false ){
    // find the right atc button
    let btn = document.querySelector('button.jsToBagBtn[data-code='+productcode.substring(5)+']');
    if ( enable ) {
      btn.disable = false;
      btn.setAttribute('disabled','false');
    } else {
      btn.disable = true;
      btn.removeAttribute('disabled');
    }
  }


  // MAIN EVENTS
  bindEvents() {
    // global
    let ctx = this;
    // intercept the form submit
    this.form.addEventListener("submit", function(e){
      // prevent the default and launch notify
      e.preventDefault();
      ctx.notifySubmit(ctx.form);
    });

    // on launch notify me , let's open the form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      let payloadData = payload.box || payload.button;
      if (payloadData.classList.contains(this.CLASSES.enableNotify)) {
        // show and bind send button
        ctx.toggleUnavailableForm(payloadData);
        ctx.notifySend();
      } else {
        // if there is no notify form , i disable the atc
        let productcode = payloadData.querySelector('[data-sizes-trigger]').getAttribute('data-sizes-trigger');
        ctx.toggleAddToCartError(true,productcode);
      }
    });

    // hide form on notifyclose
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      // if its the main ATC btn for product
      if (payload.box === false) {
        // let's close
        ctx.toggleUnavailableForm(payload.button, false);
      } else if (payload.box.classList.contains(this.CLASSES.enableNotify)) {
        // close it
        ctx.toggleUnavailableForm(payload.box, false);
      } else {
        // if there is no notify form , i enable the atc
        let productCode = payload.box.querySelector('[data-sizes-trigger]').getAttribute('data-sizes-trigger');
        ctx.toggleAddToCartError(false, productCode );
      }
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      this.sizeHiddenInput.value = payload.button.getAttribute('data-size');
      document.getElementById('size-variant-code').value = payload.button.dataset.productCode;
    });

    // on notify me ended reset select
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeended, ({event, payload}) => {
      //
      let notifyWrapper = payload.box;
      // hide wrapper
      notifyWrapper.classList.remove(ctx.CLASSES.show);
      // hide atc
      let parentEl = notifyWrapper.closest(this.SELECTORS.wishlistSelector) || notifyWrapper.closest(this.SELECTORS.pdpProduct);
      parentEl.querySelector(this.SELECTORS.notifyMeBtn).classList.add(this.CLASSES.btnHidden);
      // show thanks
      parentEl.querySelector(ctx.SELECTORS.notifyMeThanksText).innerHTML = payload.message;
      parentEl.querySelector(ctx.SELECTORS.notifyMeThanks).classList.add(ctx.CLASSES.show);
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    // for unavailable products i check if the form is visible
    if (this.nofityWrapper.classList.contains(this.CLASSES.show)) {
      this.notifySend();
    }
  }
}
